import clsx from "clsx"
export default function Separator({ className, ref }) {
  return (
    <div className={clsx("relative h-[1px]", className)}>
      <div className="w-full h-full bg-current" ref={ref} />
    </div>
  )
}